import React, { useState } from 'react';

const bannerStyle = {
  position: 'fixed',
  zIndex: 9999,
  top: 0,
  left: 0,
  right: 0,
  minHeight: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '6px 16px',
  color: '#173c2a',
  background: '#d8f4e3',
  borderBottom: '1px solid #8bc8a5',
  fontSize: '14px',
  fontWeight: 600,
};

const buttonStyle = {
  border: '1px solid #33734f',
  borderRadius: '999px',
  padding: '3px 10px',
  color: '#173c2a',
  background: '#fff',
  cursor: 'pointer',
  fontWeight: 700,
};

function loadSession() {
  try {
    const raw = window.localStorage.getItem('supportImpersonation:v1');
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session.expiresAt || session.expiresAt <= Math.floor(Date.now() / 1000)) {
      window.localStorage.removeItem('supportImpersonation:v1');
      return null;
    }
    return session;
  } catch (error) {
    return null;
  }
}

function redirectTo(path) {
  window.location.replace(path);
}

export default function SupportImpersonationBanner({ onExit = redirectTo }) {
  const [session] = useState(loadSession);
  if (!session) return null;

  const exit = () => {
    ['token', 'refreshToken', 'store', 'origin', 'supportImpersonation:v1'].forEach((key) => {
      window.localStorage.removeItem(key);
    });
    onExit('/');
  };

  return (
    <aside style={bannerStyle} role="status">
      <span>Modo soporte: {session.storeName} - solo lectura</span>
      <button type="button" style={buttonStyle} onClick={exit}>Salir</button>
    </aside>
  );
}
